import moment from 'moment';


export function formatPrice(number) {
    return new Intl.NumberFormat('en-US').format(number);
}

export function formatCurrency(amount) {
    if (amount === undefined || amount === null) return 'AED 0.00';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AED',
    }).format(amount);
}

export function formatDate(date, format = 'MMMM D, YYYY') {
    return moment(date).format(format);
}

export function timeAgo(date) {
    return moment(date).fromNow();
}

/** Seconds as HH:MM:SS — used by the running check-in timer. */
export function formatDuration(totalSeconds) {
    const seconds = Math.max(0, Math.floor(totalSeconds || 0));
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
}

/** Seconds as a compact "2h 15m" — used where a precise ticking clock is noise. */
export function formatDurationShort(totalSeconds) {
    const seconds = Math.max(0, Math.floor(totalSeconds || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours === 0 && minutes === 0) return `${seconds}s`;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
}

// "09:00" -> "9:00 AM"
export function formatTime12(hhmm) {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return hhmm;
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
}

// "09:00", "10:00" -> "9:00 AM – 10:00 AM" (start only if the end is missing)
export function formatSlotRange(start, end) {
  return end ? `${formatTime12(start)} – ${formatTime12(end)}` : formatTime12(start);
}

export function getBookingStatusBadgeClass(status) {
    const map = {
        pending: 'badge text-warning border border-warning',
        confirmed: 'badge text-info border border-info',
        in_progress: 'badge text-primary border border-primary',
        completed: 'badge text-success border border-success',
        cancelled: 'badge text-danger border border-danger',
        no_show: 'badge text-dark border border-dark'
    };
    return map[status] || 'badge text-dark border border-dark';
}

export function getPaymentStatusBadgeClass(status) {
    status = status?.toLowerCase() || '';
    if (status === 'paid') return 'badge bg-success text-capitalize';
    if (status === 'pending') return 'badge bg-warning text-dark text-capitalize';
    return 'badge bg-danger text-capitalize';
}

export function getPaymentsStatusBadgeClass(status) {
    const s = (status || '').toLowerCase();
    if (s === 'completed') return 'badge-status-complete';
    if (s === 'paid') return 'badge-status-paid';
    if (s === 'pending' || s === 'in_progress' || s === 'confirmed') return 'badge-status-pending';
    if (s === 'cancelled') return 'badge-status-cancelled';
    if (s === 'failed') return 'badge-status-failed';
    return 'badge bg-secondary';
}

// Display name for a stored payment_method ('card', 'apple_pay', 'tabby', …).
const PAYMENT_METHOD_LABELS = {
    card: 'Card',
    apple_pay: 'Apple Pay',
    tabby: 'Tabby',
    tamara: 'Tamara',
    cash: 'Cash',
    pay_per_session: 'Pay Per Session',
};

export function formatPaymentMethod(method) {
    if (!method) return '—';
    return PAYMENT_METHOD_LABELS[method] || method.replace(/_/g, ' ');
}

// Bootstrap light badge for a transaction status (see admin transactionController).
export function getTransactionStatusBadgeClass(status) {
    const s = (status || '').toLowerCase();
    if (s === 'paid') return 'badge-light-success';
    if (s === 'pending' || s === 'authorized') return 'badge-light-warning';
    if (s === 'refunded') return 'badge-light-info';
    return 'badge-light-danger';
}
